import { jsx } from 'react/jsx-runtime';
import { Icons, Anchor } from '@mirohq-internal/website-ui-foundation';

const SocialMediaLinks = ({ socialMediaLinks })=>{
    return jsx("span", {
        className: "d-flex justify-content-center gap-300",
        children: socialMediaLinks?.map((socialMediaLink)=>{
            const SocialMediaIcon = Icons?.[socialMediaLink.icon] || Icons.Placeholder;
            return jsx(Anchor, {
                href: socialMediaLink.href,
                title: socialMediaLink.label,
                children: jsx(SocialMediaIcon, {
                    size: "lg"
                })
            }, socialMediaLink.href);
        })
    });
};

export { SocialMediaLinks };
